import ExlyImage from "common/Components/ExlyImage";
import React from "react";
import { extractTextContentFromHtml } from "@my-scoot/exly-react-component-lib/build/esm/utils/common/common";
import { useNotifications } from "utils/hooks";

export const CustomNoification = ({
  target_url,
  title,
  sub_heading,
  body,
  id,
}) => {
  const { deleteNotification } = useNotifications();
  const handleClick = () => {
    if (!target_url) return;
    window.location.replace(target_url);
    deleteNotification(id);
  };

  return (
    <div
      className="!tw-flex !tw-flex-col tw-w-[200px] tw-cursor-pointer"
      onClick={handleClick}
    >
      <p className="tw-text-[16px] tw-font-semibold tw-text-[#11142D] vertical__one_line">
        {title}
      </p>
      <p className="tw-text-[13px] tw-text-[#8D8D8D] vertical__one_line">
        {sub_heading}
      </p>
      <p
        className="!tw-mt-1 tw-text-[14px] tw-text-[#000000] vertical__one_line"
        dangerouslySetInnerHTML={{
          __html: extractTextContentFromHtml(body || ""),
        }}
      ></p>
    </div>
  );
};

export const CustomNotificationIcon = ({
  iconUrl = "https://myscoot-images.s3.ap-south-1.amazonaws.com/misc/exly_icon.png",
}) => {
  return <ExlyImage src={iconUrl} alt="notification icon" height={40} />;
};
